import React from 'react';
import AkAppIcon from '@atlaskit/icon/core/migration/app--addon';
import { token } from '@atlaskit/tokens';
import { IconCustom } from '@atlassian/jira-icon-custom/src/index.tsx';

export const AppIcon = ({ iconUrl }: { iconUrl: string | null }) => {
	return iconUrl != null ? (
		<IconCustom shouldChangeFillColor={false} url={iconUrl} />
	) : (
		<AkAppIcon
			color={token('color.icon')}
			spacing="spacious"
			LEGACY_primaryColor={token('color.icon')}
			label=""
			testId="issue-navigator-action-pluggable-items.ui.dropdown-item.app-icon.default-icon"
		/>
	);
};
